import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'reports-detail',
    templateUrl: 'reports-detail.component.html',
    standalone: false
})
export class ReportsDetailComponent implements OnInit {
  @Input() show: boolean;
	@Input() id: number;
  constructor() { }

  ngOnInit() {
  }

}
